import { object } from "../../../../helpers/object";
import { debug } from "../../../../helpers/debug";

/*------------------------------------*\
  #INPUT SELECT
  select affichant du texte complémentaire
\*------------------------------------*/
class FormSelect {


  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    document.addEventListener('change', this.inputHandler);

    if(debug.DEBUG) console.log('async/form/modules/field-behavior/select.js');
  };
  /**
   * INPUT HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  inputHandler = (event) => {
    if (event.target.matches('[data-js-trigger="show-complementary"]')) {
      const id = event.target.options[event.target.selectedIndex].id;
      // this.hideAllComplementary(event.target);
      this.showComplementary(event.target, id);
    }
  }
  /**
   * Hides all complementary elements associated with the options of the given target.
   *
   * @param {HTMLElement} target - The target element containing the options.
   */
  hideAllComplementary = (target) => {
    target.querySelectorAll('option').forEach(option => {
      this.showComplementary(option.id, false);
    });
  };
  /**
   * Toggles the visibility of complementary elements based on the selected option.
   *
   * @param {HTMLElement} target - The target element containing the options.
   * @param {string} id - The ID of the option to match for showing complementary elements.
   */
  showComplementary = (target, id) => {
    if (!id) return;
  
    target.querySelectorAll('option').forEach((option) => {
      const isVisible = option.id === id;
      const complementaryTarget = document.querySelector(`[data-js-select-complementary="${option.id}"]`);
      
      if (complementaryTarget) {
        complementaryTarget.classList.toggle('u-hidden', !isVisible);
        complementaryTarget.setAttribute('aria-hidden', !isVisible);
      }
    });
  };

}
export default new FormSelect('[data-js-component="select"]'); 